<template>
  <div class="po-sold" style="width:820px;margin:0 auto;background-color:#fff;">
    <div style="margin-top:20px;font-size:20px;text-align:center;">
      Sold To
    </div>
    <div style="margin-top:20px;">
      PO NO.:&nbsp;<a @click="view">CYS{{ $route.params.id }}</a><br/>
      Company:&nbsp;{{ doc.company_name }}<br/>
      Date:&nbsp;{{ doc.doc_date }}<br/>
      Details:&nbsp;<!--<el-input v-model="form.sold_details" style="width:300px;"></el-input>-->
    </div>
    <table class="normal-table" style="margin-top:20px;">
      <tr>
        <th>#</th>
        <th>Item</th>
        <th>Qty</th>
        <th>Cost</th>
        <th>&nbsp;</th>
      </tr>
      <tr v-for="(item, index) in productList">
        <td style="vertical-align:top;">{{ index + 1 }}</td>
        <td style="vertical-align:top;">
          <a @click="$open(`/product/${item.product_id}/details`)">{{ item.part_no }}</a><br/>
          {{ item.description }}<br/>
          {{ item.brand }}
        </td>
        <td style="text-align:right;vertical-align:top;">{{ item.qty }}</td>
        <td style="text-align:right;vertical-align:top;">{{ doc.currency }}{{ item.price }}</td>
        <td>
          <table class="normal-table inner-table" v-if="item.qty_bb > 0 || item.sold_bb > 0">
            <tr>
              <td rowspan="10" style="vertical-align:top;">
                <strong>BB</strong><br/>
                ({{ item.qty_bb }})<br/><br/>
                <el-button type="primary" @click="save(item)" :disabled="doc.is_locked === '1'">Save</el-button>
              </td>
              <td>del</td>
              <td>Qty</td>
              <td>Price(USD)</td>
              <td>Company</td>
              <td>Remark</td>
            </tr>
            <tr v-for="(sold, i) in item.solds" v-if="sold.type === 'bb'">
              <td><el-button type="danger" style="padding:0;" @click="del(productList[index], i)">del</el-button></td>
              <td><el-input v-model.number="productList[index].solds[i].qty" class="input-number" style="width:60px;"></el-input></td>
              <td><el-input v-model.number="productList[index].solds[i].price" class="input-number" style="width:60px;"></el-input></td>
              <td><el-input v-model="productList[index].solds[i].company" style="width:120px;"></el-input></td>
              <td><el-input v-model="productList[index].solds[i].remark" style="width:120px;"></el-input></td>
            </tr>
            <tr>
              <td colspan="5"><el-button @click="addNew(productList[index], 'bb')">Add</el-button></td>
            </tr>
          </table>
          <table v-if="item.qty_hk > 0 || item.sold_hk > 0">
            <tr>
              <td rowspan="10" style="vertical-align:top;">
                <strong>HK Stock</strong><br/>
                ({{ item.qty_hk }})<br/><br/>
                <el-button type="primary" @click="save(item)" :disabled="doc.is_locked === '1'">Save</el-button>
              </td>
              <td>del</td>
              <td>Qty</td>
              <td>Price(USD)</td>
              <td>Company</td>
              <td>Remark</td>
            </tr>
            <tr v-for="(sold, i) in item.solds" v-if="sold.type === 'hk'">
              <td><el-button type="danger" style="padding:0;" @click="del(productList[index], i)">del</el-button></td>
              <td><el-input v-model.number="productList[index].solds[i].qty" class="input-number" style="width:60px;"></el-input></td>
              <td><el-input v-model.number="productList[index].solds[i].price" class="input-number" style="width:60px;"></el-input></td>
              <td><el-input v-model="productList[index].solds[i].company" style="width:120px;"></el-input></td>
              <td><el-input v-model="productList[index].solds[i].remark" style="width:120px;"></el-input></td>
            </tr>
            <tr>
              <td colspan="5"><el-button @click="addNew(productList[index], 'hk')">Add</el-button></td>
            </tr>
          </table>
          <table v-if="item.qty_sz > 0 || item.sold_sz > 0">
            <tr>
              <td rowspan="10" style="vertical-align:top;">
                <strong>SZ Stock</strong><br/>
                ({{ item.qty_sz }})<br/><br/>
                <el-button type="primary" @click="save(item)" :disabled="doc.is_locked === '1'">Save</el-button>
              </td>
              <td>del</td>
              <td>Qty</td>
              <td>Price(USD)</td>
              <td>Company</td>
              <td>Remark</td>
            </tr>
            <tr v-for="(sold, i) in item.solds" v-if="sold.type === 'sz'">
              <td><el-button type="danger" style="padding:0;" @click="del(productList[index], i)">del</el-button></td>
              <td><el-input v-model.number="productList[index].solds[i].qty" class="input-number" style="width:60px;"></el-input></td>
              <td><el-input v-model.number="productList[index].solds[i].price" class="input-number" style="width:60px;"></el-input></td>
              <td><el-input v-model="productList[index].solds[i].company" style="width:120px;"></el-input></td>
              <td><el-input v-model="productList[index].solds[i].remark" style="width:120px;"></el-input></td>
            </tr>
            <tr>
              <td colspan="5"><el-button @click="addNew(productList[index], 'sz')">Add</el-button></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div v-if="doc.is_locked === '1'" style="font-size:14px;font-weight:bold;">
      ***此单已锁，如需修改，请向管理员申请！
    </div>
    <div style="height:50px;">&nbsp;</div>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      form: {
        id: 0,
        sold_details: ''
      },
      doc: {
        id: 0,
        company_name: '',
        doc_date: ''
      },
      productList: []
    }
  },
  mounted () {
    this.fetchDoc()
    this.fetchProductList()
  },
  methods: {
    fetchDoc () {
      this.$http.get('/dbapi/po_doc_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.doc = data.list[0]
          this.form.id = this.doc.id
          //this.form.sold_details = this.doc.sold_details
        }
      })
    },
    fetchProductList () {
      this.$http.get('/dbapi/po_sold_list?doc_id=' + this.$route.params.id).then(data => {
        let arr = data.list
        let list = []
        for (let i = 0; i < arr.length; i++) {
          if (i === 0 || arr[i].id !== arr[i - 1].id) {
            list.push({
              id: arr[i].id,
              product_id: arr[i].product_id,
              part_no: arr[i].part_no,
              description: arr[i].description,
              brand: arr[i].brand,
              qty: arr[i].product_qty,
              price: arr[i].product_price,
              qty_bb: arr[i].qty_bb,
              qty_hk: arr[i].qty_hk,
              qty_sz: arr[i].qty_sz,
              solds: [],
              sold_bb: 0,
              sold_hk: 0,
              sold_sz: 0
            })
          }
        }
        let bb = 0
        let hk = 0
        let sz = 0
        for (let i = 0; i < list.length; i++) {
          bb = 0
          hk = 0
          sz = 0
          for (let j = 0; j < arr.length; j++) {
            if (arr[j].po_id === list[i].id) {
              list[i].solds.push({
                type: arr[j].type,
                qty: arr[j].qty,
                price: arr[j].price,
                company: arr[j].company,
                remark: arr[j].remark
              })
              if (arr[j].type === 'bb') {
                bb++
                list[i].sold_bb = list[i].sold_bb + 1
              } else if (arr[j].type === 'hk') {
                hk++
                list[i].sold_hk = list[i].sold_hk + 1
              } else {
                sz++
                list[i].sold_sz = list[i].sold_sz + 1
              }
            }
          }
          while (bb < 3) {
            list[i].solds.push({
              type: 'bb',
              qty: '',
              price: '',
              company: '',
              remark: ''
            })
            bb++
          }
          while (hk < 2) {
            list[i].solds.push({
              type: 'hk',
              qty: '',
              price: '',
              company: '',
              remark: ''
            })
            hk++
          }
          while (sz < 2) {
            list[i].solds.push({
              type: 'sz',
              qty: '',
              price: '',
              company: '',
              remark: ''
            })
            sz++
          }
        }
        this.productList = list
      })
    },
    addNew (item, type) {
      item.solds.push({
        type: type,
        qty: '',
        price: '',
        company: '',
        remark: ''
      })
    },
    del (item, i) {
      item.solds.splice(i, 1)
    },
    save (item) {
      let solds = item.solds.filter(r => r.qty > 0)
      for (let i = 0; i < solds.length; i++) {
        solds[i].doc_id = this.$route.params.id
        solds[i].po_id = item.id
      }
      this.$http.post('/dbapi/po_sold', {
        solds
      }).then(data => {
        this.$message({
          type: 'success',
          message: '保存成功.'
        })
        window.opener && window.opener.postMessage('cystron', '*') // 刷新主页列表
      })
    },
    view () {
      window.open(`/po-order-view/${this.$route.params.id}`, `po-order-view`, 'height=750,width=800,top=50,left=200,toolbar=yes,menubar=yes,scrollbars=no,resizable=yes,location=no,status=no')
    }
  }
}
</script>